<template>
  <div class="accountConfigBar">
    <v-sheet class="accountConfigBar_main">
      <div class="accountConfigBar_title">
        <div class="accountConfigBar_title_text">マイアカウント</div>
      </div>
      <div class="accountConfigBar_header">
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="accountConfigBar_header_name">
                {{ avatarName }}
                <span v-if="isOwner" class="accountConfigBar_header_owner">
                  組織管理者
                </span>
              </v-list-item-title>
              <v-list-item-subtitle class="accountConfigBar_header_email">{{
                userEmail
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
      <div class="accountConfigBar_events_container">
        <div class="accountConfigBar_events">
          <config-bar-link
            v-for="(setting, i) in helps"
            :key="`helps-link-${i}`"
            :setting="setting"
            :active="setting.key === activeSetting"
          />
          <router-link
            v-ripple
            class="cofigBarLink customConfig_logout"
            to
            @click.native="logout"
          >
            <div class="cofigBarLink_root">
              <div class="cofigBarLink_title">
                <span>ログアウト</span>
              </div>
            </div>
          </router-link>
          <section class="customConfig_externalLink">
            <a href="https://faq.secomsights.com" target="_blank"
              >ヘルプセンター（操作ガイド）
              <img src="@/assets/img/icon_newwin.svg" alt=""
            /></a>
            <a href="https://www.secomsights.com/terms" target="_blank"
              >サービス利用規約</a
            >
            <a
              href="https://www.secom.co.jp/utility/privacy.html"
              target="_blank"
              >プライバシーポリシー</a
            >
            <a href="https://www.secomsights.com/cookie" target="_blank"
              >クッキーポリシー</a
            >
            <a href="https://www.secomsights.com/oss" target="_blank"
              >オープンソースソフトウェアについて</a
            >
          </section>
          <router-link class="cofigBarLink customConfig_webVersion" to>
            <div class="cofigBarLink_root">
              <div class="cofigBarLink_title d-flex justify-space-between">
                <span>バージョン番号</span>
                <span class="pr-2">{{ webVersion }}</span>
              </div>
            </div>
          </router-link>
          <!-- <v-divider class="accountConfigBar_divider" />-->
        </div>
      </div>
    </v-sheet>
    <app-dialog-a
      :open="dialogLogoutOpen"
      title="ログアウト"
      @onClose="closeDialogLogout"
    >
      <div class="accountConfigBar_dialog-content">
        ログアウトしてもよろしいですか？
      </div>
      <template #actions>
        <v-btn
          class="accountConfigBar_dialog-btn accountConfigBar_dialog-cancel"
          color="text"
          @click="closeDialogLogout"
        >
          キャンセル
        </v-btn>
        <v-spacer />
        <v-btn
          class="accountConfigBar_dialog-btn accountConfigBar_dialog-ok"
          color="primary"
          :loading="loadingLogout"
          @click="handleLogoutOk"
        >
          ログアウト
        </v-btn>
      </template>
    </app-dialog-a>
  </div>
</template>

<script>
import ConfigBarLink from '@/components/settings/ConfigBarLink.vue';
import { mapState } from 'vuex';
import { authService } from '@/services/auth.service';

export default {
  name: 'AccountConfigBar',
  components: {
    ConfigBarLink,
  },
  data: () => ({
    dialogLogoutOpen: false,
    loadingLogout: false,
  }),
  computed: {
    ...mapState({
      userInfo: (state) => state.common.userInfo,
      webVersion: (state) => state.common.webVersion,
      avatarOwnerIds: (state) => state.settings.avatarOwnerIds,
      avatarName: (state) => state.settings.avatarName,
      currentAvatarId: (state) => state.settings.currentAvatarId,
    }),
    isOwner() {
      return this.avatarOwnerIds.includes(this.currentAvatarId);
    },
    userEmail() {
      return this.userInfo && this.userInfo.attributes
        ? this.userInfo.attributes.email
        : null;
    },
    activeSetting() {
      return this.$route.params.parent;
    },
    helps() {
      return [
        // {
        //   title: 'メールアドレス変更',
        //   desc: 'ログイン時のメールアドレス変更',
        //   to: { name: 'account-email' },
        // },
        {
          title: 'ユーザー名の設定',
          desc: 'ユーザー名の変更',
          to: { name: 'account-name' },
        },
        {
          title: 'パスワード設定',
          desc: 'SECOM Sights IDパスワードの変更',
          to: { name: 'account-password' },
        },
        {
          title: 'セキュリティ設定',
          desc: '多要素認証によるセキュリティ設定',
          to: { name: 'account-mfa' },
        },
      ];
    },
  },
  methods: {
    logout() {
      this.dialogLogoutOpen = true;
    },
    async handleLogoutOk() {
      this.loadingLogout = true;
      try {
        await authService.logout();
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingLogout = false;
      }
    },
    closeDialogLogout() {
      this.dialogLogoutOpen = false;
    },
  },
};
</script>

<style lang="scss">
.accountConfigBar {
  &_header {
    margin-bottom: 6px;
    padding: 0 5px 0 10px;
    & .v-sheet.v-list:not(.v-sheet--outlined) {
      padding: 0;
    }
    & .v-sheet.v-card:not(.v-sheet--outlined) {
      width: 300px;
      height: 165px;
      padding: 8px 0;
      border-radius: 10px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.12);
      background-color: #fff;
    }
    & .v-list-item {
      padding: 0;
    }
    & .v-list-item__title {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #666;
    }
    & .v-list-item__icon:first-child {
      margin-right: 6px;
    }
    &_owner {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.75;
      letter-spacing: normal;
      text-align: left;
      color: #989898;
      margin-left: 3px;
    }
    &_name {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #666;
    }
    &_email {
      &.v-list-item__subtitle {
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.75;
        letter-spacing: normal;
        text-align: left;
        color: #989898 !important;
      }
    }
  }
  &_notification {
    &.v-sheet.theme--light {
      .accountConfigBar & {
        flex-grow: 0;
        margin-bottom: 30px;
        color: #fff;
        background-color: var(--primary-color);
        padding-bottom: 16px;
        box-shadow: 0 3px 12px 0 rgba(0, 45, 170, 0.19);
      }
    }
    &_supTitle {
      font-size: 14px;
      font-weight: 600;
      line-height: 17px;
      margin-bottom: 7px;
    }
    &_title {
      font-size: 16px;
      font-weight: 600;
      line-height: 21px;
      margin-bottom: 2px;
    }
    .eventItem {
      border-top: 0;
      padding-left: 0;
      padding-right: 0;
    }
    .eventItem_time {
      color: #fff;
    }
    .eventItem_date {
      font-weight: 400;
    }
    .eventItem_hour {
      font-weight: 400;
    }
    .eventItem_chevron {
      display: none;
    }
  }
  &_main {
    &.v-sheet {
      padding-right: 22px;
    }
  }
  &.v-sheet {
    padding-right: 22px;
  }
  &_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
    padding-right: 8px;
    &_text {
      font-size: 14px;
      font-weight: 600;
      color: var(--text-color);
    }
    &_btn {
      .icon {
        margin-left: 8px;
        margin-right: -5px;
        position: relative;
      }
    }
    &_icon {
      &-open {
        transform: rotate(180deg);
      }
    }
  }
  &_divider {
    border-color: #ccc;
  }
  &_events {
    padding-right: 8px;
    &_container {
    }
  }
  &_dialog {
    position: relative;
    &-cancel {
      &.v-btn:not(.v-btn--round).v-size--default {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: center;
        color: #989898;
      }
    }
    &-ok {
      &.v-btn:not(.v-btn--round).v-size--default.primary {
        width: 120px;
        height: 36px;
        padding: 8px 16px;
        border-radius: 5px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
        background-color: #0075c2;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.14;
        letter-spacing: normal;
        text-align: center;
        color: #fff;
      }
    }
    &-btn {
      width: 120px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
    }
    &-content {
      margin: 20px 0;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      color: #666;
    }
  }
  .customConfig {
    &_logout {
      height: 40px;
      background-color: white !important;
      .cofigBarLink_title {
        font-size: 14px;
        font-weight: bold;
        line-height: 1.5;
      }
    }
    &_externalLink {
      padding: 9px 5px 10px 10px;
      border-top: 1px solid #ccc;
      cursor: unset;
      background-color: white !important;
      a {
        display: block;
        padding-bottom: 10px;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;
        color: #4b4b4b;
        &:first-child {
          padding-top: 10px;
        }
      }
    }
    &_webVersion {
      height: 40px;
      pointer-events: none;
      cursor: unset !important;
      background-color: white !important;
      .cofigBarLink_title {
        font-size: 14px;
        line-height: 1.5;
        font-weight: normal;
      }
    }
  }
}
</style>
